import { render, staticRenderFns } from "./AcademyTutorial.vue?vue&type=template&id=3108508c&scoped=true&"
import script from "./AcademyTutorial.vue?vue&type=script&lang=js&"
export * from "./AcademyTutorial.vue?vue&type=script&lang=js&"
import style0 from "./AcademyTutorial.vue?vue&type=style&index=0&id=3108508c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108508c",
  null
  
)

export default component.exports